<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5> {{ $t('Device filter')}} </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
         
 
        <b-col md="12" sm="12" lg="6" class="mb-md-0 mb-2">
          <label>{{ $t('Category') }} ( optional ) (  اختياري )</label>
          <v-select multiple :close-on-select="false"
                   :dir="$store.getters['auth/preferDirIsRtl']  ? 'rtl' : 'ltr'"
                    label="name"
                    :options="categoriesOptions.map(i=>({id:i,name:$t(i)}))"
                    v-model="filter_request.categories"
                    class="w-100"
                    v-on:input="filterDataChanged() ,refilterTypesByCategorey(filter_request.categories)"
                    :reduce="val=>val.id"
          />
        </b-col>

        <b-col lg="6" md="12" class="mb-md-0 mb-2">
          <label>{{$t('Owners')}} ( optional ) (  اختياري ) </label>
          <v-select multiple :close-on-select="false"
                 :dir="$store.getters['auth/preferDirIsRtl']  ? 'rtl' : 'ltr'"
                   
                    label="name"
                    :options="ownersOptions"
                    v-model="filter_request.owners"
                    class="w-100"
                    :reduce="val => val.id"
                    v-on:input="filterDataChanged"
          />
        </b-col>

        <b-col lg="6" md="12" class="mb-md-0 mb-2">
          <label>{{$t('types')}} ( optional ) (  اختياري ) </label>
          <v-select
             
              :dir="$store.getters['auth/preferDirIsRtl']  ? 'rtl' : 'ltr'"              
              :options="typesOptions"
              :getOptionLabel="t => t.name"
              v-model="filter_request.types"
              class="w-100"
              :reduce="val => val.id"
              v-on:input="filterDataChanged"
          />
        </b-col>

        <b-col lg="6" md="12" class="mb-md-0 mb-2">
          <label>{{$t('Contracts')}} ( optional ) (  اختياري ) </label>
        
          <v-select  :close-on-select="false"
                 :dir="$store.getters['auth/preferDirIsRtl']  ? 'rtl' : 'ltr'"
                 multiple
                    :getOptionLabel="c => c.name"
                    :options="contractsOptions"
                    v-model="filter_request.contracts"
                    class="w-100"
                    :reduce="val => val.id"
                     v-on:input="filterDataChanged"
          />
        </b-col>


      </b-row>
      <b-row>

        <b-col v-if="haseSupportFilter" lg="12" md="12" class="mb-md-0 mb-2">
          <label>{{ $t('Support Devices') }}</label>
          
          <v-select   :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" 
             v-model="filter_request.isSupport"
             :getOptionLabel="c =>$t( c.name)"
             :placeholder="$t('all')"
             :options="[{id:'all',name:'all'},{id:'true',name:'Support Devices'},{id:'false',name:'Not Support devices'}]" 
             class="w-100" 
             :reduce="val => val.id"
             v-on:input="filterDataChanged"
           
            
            />
        </b-col>
      </b-row>
     
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BButton, VBToggle, BCollapse
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Filter   from './filter.js'
import FilterLogic   from './filterLogic.js'
import { ReportService } from '@/app/reports/share/report.service'
import store from '@/store'

import { ref,onMounted,watch ,defineProps} from '@vue/composition-api'
import { request } from 'http'
export default {
  components: {
    BRow,BButton,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
  },

  props:{
     oldFilterData:{
      type:Object,     
     },
     filterFor:{
      type:String,
       default:'report'
     },
     haseSupportFilter:{
      type:Boolean,
      default:false
     },
     showOnleyNotSupport:{
      type:Boolean,
      default:false
     }

    },

  watch: { 
    oldFilterData: function(newVal, oldVal) { // watch it
      
        if(this.filterFor=='setting'){
          this.fillFilter(newVal);
        }
        }
      },
  setup(props, { emit }){
    

  
   const {filter_request,reFilter,devices}  =FilterLogic(props.showOnleyNotSupport);
   const{ ownersOptions,typesOptions,typesOptions_orig,categoriesOptions,contractsOptions,areasContractsOptions_orig}= Filter('device')

    const refilterTypesByCategorey=(cats)=>{
      
      if(cats.length >0 ){
    typesOptions.value= JSON.parse(JSON.stringify(typesOptions_orig.value.filter(t=>cats.includes(t.category))))
      }else{
        typesOptions.value=JSON.parse(JSON.stringify(typesOptions_orig.value))
      }
    }

    const refliterContractByWoners=(owners)=>{
          
          let result=areasContractsOptions_orig.value.filter((i)=>owners.includes(i.contractor_id))
         
          contractsOptions.value=result;
           if(owners.length==0){
            contractsOptions.value=JSON.parse(JSON.stringify(areasContractsOptions_orig.value));
          }
         
        }
 

   const filterDataChanged =()=>{
    refliterContractByWoners(filter_request.value.owners)
     
    let requestFilterDevice=filter_request.value;  
    
    if(props.showOnleyNotSupport==true){
      Object.assign(requestFilterDevice,{isSupport:false})
    }
    
    emit('merageFilterWithRequest', filter_request.value);

     

      if( requestFilterDevice.isSupport=="all"){
        
        delete  requestFilterDevice.isSupport;
        
      }
      
       ReportService.getDevicesOptions(
      Object.assign(  requestFilterDevice,{
       type:'device',
       user: store.state.auth.userData.id
   
   })
     ).then(response => {
       
       devices.value = response.data.map((d)=>({id:d.device_id,"name":d.name}))
             emit('divicesFilterd', devices.value);
          
      })
     .catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
     .finally(() => {})
   

   }
 




const fillFilter=(data)=>{
 
  
  Object.assign(filter_request.value,data)
}


    return { 
    ownersOptions,
    typesOptions,
    categoriesOptions,
    contractsOptions,
    filter_request,
    filterDataChanged,
    reFilter,
    devices,
    ReportService,
    fillFilter,
    refilterTypesByCategorey
  
    }

  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
